import __vue_component__$1 from '../HseIcon/HseIcon.vue.js';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import __vue_component__ from '../HseSpinner/HseSpinner.vue.js';
import { IconButtonSize } from './IconButtonSize.js';
import { IconButtonVariant } from './IconButtonVariant.js';
import InteractionBubbles from '../../mixins/InteractionBubbles.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=8164%3A32420
 * @storybook /?path=/story/inputs-iconbutton--icon-button-default
 * @react /src-components-icon-button
 * @reactStorybook /?path=/story/inputs-iconbutton--icon-button-default
 */
var HseIconButton = /** @class */ (function (_super) {
    __extends(HseIconButton, _super);
    function HseIconButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focused = false;
        return _this;
    }
    Object.defineProperty(HseIconButton.prototype, "enabled", {
        get: function () {
            return !this.disabled && !this.inactive;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseIconButton.prototype, "spinnerProps", {
        get: function () {
            var props = {};
            if (this.spinner === true) {
                props.loading = true;
            }
            else if (this.spinner === 'done') {
                props.done = true;
            }
            else if (typeof this.spinner === 'number') {
                props.value = this.spinner;
            }
            props.size = this.iconSize;
            return props;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseIconButton.prototype, "iconSize", {
        get: function () {
            return this.size === 'small' ? 'small' : 'medium';
        },
        enumerable: false,
        configurable: true
    });
    HseIconButton.prototype.warn = function () {
        if (this.variant === IconButtonVariant.pagination && this.size !== IconButtonSize.medium) {
            console.warn("IconButton with variant 'pagination' must be of size 'medium'");
        }
        if (this.spinner && this.variant !== IconButtonVariant.default) {
            console.warn("IconButton with 'spinner' prop must be of type 'default'");
        }
    };
    __decorate([
        Prop({
            default: 'button'
        }),
        __metadata("design:type", Object)
    ], HseIconButton.prototype, "component", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseIconButton.prototype, "color", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], HseIconButton.prototype, "icon", void 0);
    __decorate([
        Prop(EnumProp(IconButtonSize.medium, IconButtonSize)),
        __metadata("design:type", String)
    ], HseIconButton.prototype, "size", void 0);
    __decorate([
        Prop(EnumProp(IconButtonVariant.default, IconButtonVariant)),
        __metadata("design:type", String)
    ], HseIconButton.prototype, "variant", void 0);
    __decorate([
        Prop({
            validator: function (v) {
                return ['boolean', 'number'].includes(typeof v) || v === 'done';
            }
        }),
        __metadata("design:type", Object)
    ], HseIconButton.prototype, "spinner", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseIconButton.prototype, "selected", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseIconButton.prototype, "disabled", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseIconButton.prototype, "inactive", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseIconButton.prototype, "iconColor", void 0);
    __decorate([
        Prop({
            default: function () { return ({
                content: '',
                icon: '',
                spinner: ''
            }); }
        }),
        __metadata("design:type", Object)
    ], HseIconButton.prototype, "classes", void 0);
    HseIconButton = __decorate([
        Component({
            name: 'HseIconButton',
            components: {
                HseSpinner: __vue_component__,
                HseIcon: __vue_component__$1
            }
        })
    ], HseIconButton);
    return HseIconButton;
}(Mixins(InteractionBubbles)));

export default HseIconButton;
